import { useEffect, useRef } from "react";

import { useApi, ApiNames } from "./api";

export const usePatientMergeInfo = (patientId) => {
  const [fetchMergeInfo, mergeInfo, , error] = useApi(ApiNames.PatientMergeInfo);

  // `useApi` returns a fresh `fetchMergeInfo` identity every render, so it is called
  // through a ref and kept out of the effect's dep array below — adding it would loop.
  const fetchMergeInfoRef = useRef(fetchMergeInfo);
  fetchMergeInfoRef.current = fetchMergeInfo;

  useEffect(() => {
    if (patientId) {
      fetchMergeInfoRef.current(patientId);
    }
  }, [patientId]);

  useEffect(() => {
    if (error) {
      console.error("Failed to fetch patient merge info:", error);
    }
  }, [error]);

  return mergeInfo;
};
